import {style} from 'typestyle'
import * as csstips from 'csstips'

export const FloatCodeBox = style({
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 300,
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center
})

export const FloatCodeMask = style({
    width: '100%',
    height: '100%',
    opacity: 0.5,
    background: '#000000',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 300
})

export const FloatCodeContainer = style({
    width: '78vw',
    maxWidth: 295,
    background: '#FFFFFF',
    borderRadius: 12,
    padding: 24,
    textAlign: 'center',
    zIndex: 301,
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    ...csstips.flexRoot,
    ...csstips.vertical,
    ...csstips.centerJustified,
    ...csstips.center,
    ...csstips.wrap
})

export const FloatCodeTitle = style({
    fontSize: 24,
    color: '#333333',
    letterSpacing: 0,
    textAlign: 'center',
    marginBottom: 15,
    fontWeight: 600,
    $nest: {
        '@media (max-width: 330px)': {
            fontSize: 16
        }
    }
})

export const FloatCodeImgBox = style({
    width: '46vw',
    maxWidth: 170,
    background: '#FFFFFF',
    border: '2px solid #FFFFFF',
    boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.20)',
    borderRadius: 6,
    overflow: 'hidden',

    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,

    marginBottom: 16
})

export const FloatCodeImgBoxImg = style({
    width: '120%',
    height: '120%',
    background: '#666666'
})

export const FloatCodeSubtitle = style({
    fontSize: 18,
    color: '#FF5A31',
    letterSpacing: 0,
    textAlign: 'center',

    marginBottom: 15,
    $nest: {
        '@media (max-width: 330px)': {
            fontSize: 13
        }
    }
})

export const FloatCodeContent = style({
    fontSize: 18,
    color: '#666666',
    whiteSpace: 'pre',
    $nest: {
        '@media (max-width: 330px)': {
            fontSize: 13
        }
    }
})



// WEBPACK FOOTER //
// ./src/views/FreeLecture/components/FloatCode/FloatCodeStyle.ts